<script>
  import { readable } from "svelte/store";
  import { onMount } from "svelte";
  import {External, M} from "../../external";

  export let data;
  export let onRemove;
  export let onEdit;
  export let onPin;
  export let editable;

  let text = "";
  function startTimer() {
    // assign the stop function to unsubscribe
    time.subscribe((value) => {
      // add the previous value to the current number of milliseconds
      let time = (Date.now() - data.modified) / 1000;
      if (time < 60) {
        text = M.LESS_THAN_MINUTE_AGO;
      } else if (time >= 60 && time < 60 * 60) {
        let conv = Math.floor(time / 60);
        if (conv === 1) text = M.MINUTE_AGO;
        else text = External.format(M.MINUTES_AGO, "x", conv);
      } else if (time >= 60 * 60 && time < 60 * 60 * 24) {
        let conv = Math.floor(time / 60 / 60);
        if (conv === 1) text = M.HOUR_AGO;
        else text = External.format(M.HOURS_AGO, "x", conv);
      } else if (time >= 60 * 60 * 24 && time < 60 * 60 * 24 * 6) {
        let conv = Math.floor(time / 60 / 60 / 24);
        if (conv === 1) text = M.DAY_AGO;
        else text = External.format(M.DAYS_AGO, "x", conv);
      } else {
        text = External.Tools.dateToString(new Date(data.modified), true, true);
      }
    });
  }

  const time = readable(0, function start(set) {
    const beginning = new Date();
    const beginningTime = beginning.getTime();

    const interval = setInterval(() => {
      const current = new Date();
      const currentTime = current.getTime();
      set(currentTime - beginningTime);
    }, 10);

    return function stop() {
      // ! forcedly set the readable value to 0 before clearing the interval
      // it seems the store would otherwise retain the last value and the application would stagger from this value straight to 0
      set(0);
      clearInterval(interval);
    };
  });

  let oldMessage = data.message;

  const onCancelEdit = () => {
    data.message = oldMessage;
    onEdit();
  };

  const onKeyPress = (e) => {
    if (e.charCode === 13) onEdit();
  };

  onMount(function () {
    startTimer();
  });
</script>

<li>
  <h4 class="col20 f-left mt-25 mb-5 t-left" style="line-height:1.4;">
    {data.fullname} - <span class="light-gray-text t-left" style="font-size:14px;">{text}</span>
  </h4>
  <div class="add-automation-rule automation-comment flex align-center">
    {#if !editable}
      <div class="flex-1"><h6>{data.message}</h6></div>
      <a on:click={onEdit} class="mr-5"><span class="material-icons-outlined"> edit </span></a>
      <a on:click={onRemove} class="mr-5"><span class="material-icons-outlined"> delete </span></a>
      <a on:click={onPin} class="comment-pin {data.active ? 'active' : ''} rounded-effect"><span class="material-icons-outlined"> push_pin </span></a>
    {:else}
      <div class="flex-1 mr-10">
        <input type="text" bind:value={data.message} on:keypress={onKeyPress} placeholder={M.ADD_NEW_COMMENT} class="focus transition-border rounded-effect" />
      </div>
      <a on:click={onEdit} class="mr-5"><span class="material-icons-outlined"> check </span></a>
      <a on:click={onCancelEdit} class="mr-5"><span class="material-icons-outlined"> close </span></a>
    {/if}
  </div>
</li>
